import PropTypes from '../../_utils/props-types';
export const menuManagementProps = () => ({
    prefixCls: PropTypes.string,
    dataSource: Array,
    data: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'GET',
                params: {},
                callback: null
            };
        }
    },
    createMenu: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'POST',
                params: {},
                callback: null
            };
        }
    },
    updateMenu: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'PUT',
                params: {},
                callback: null
            };
        }
    },
    deleteMenu: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'DELETE',
                params: {},
                callback: null
            };
        }
    },
    paginationLocale: PropTypes.any
});
